// extracted by mini-css-extract-plugin
module.exports = {"brafEditor":"index_brafEditor__2Rl1K"};